import React from 'react';
import Resources from 'containers/Resources';

const ResourcesPage = (props) => <Resources {...props} />;

export default ResourcesPage;
